<style>
.jsoneditor-frame {
  display: none !important;
}

.modal-content {
  width: 600px
}

.jsoneditor-vue {
  height: 250px !important
}
</style>
<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          <strong>Lista de Workflows</strong>
          <router-link :to="'workflows/new'" class="btn btn-secondary btn-sm pull-right" exact>
            <i class="fa fa-plus"></i> Novo Workflow
          </router-link>
        </div>
        <div class="card-block">
          <table class="table table-bordered">
            <thead class="thead-inverse">
              <tr>
                <th>Workflow</th>
                <th>Última Atualização</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in orderedItems" :key="row.id">
                <td>
                  <router-link :to="'workflows/' + row.id">{{ row.name }}</router-link>
                </td>
                <td>{{row.lastUpdate | formatDate}}</td>
                <td class="actions">
                  <button type="button" class="btn btn-link" @click="showTestModal(row)">
                    <i class="fa fa-play-circle"></i>
                  </button>
                  <router-link :to="'workflows/versions/' + row.id">
                    <button title="Visualizar versões" type="button" class="btn btn-link">
                      <i class="fa fa-navicon"></i>
                    </button>
                  </router-link>
                  <button title="Remover" type="button" class="btn btn-link" @click="showModal(row)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!--Modal para remoção de workflow-->
          <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
              <span class="modal-title">
                <strong>Excluir Workflow</strong>
              </span>
            </div>
            <div slot="modal-body" class="modal-body">Deseja excluir o workflow
              <strong>{{ workflow.name }}</strong>?
            </div>
            <div slot="modal-footer" class="modal-footer">
              <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
              <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteItem">Confirmar</button>
            </div>
          </modal>

          <!--Modal de teste -->
          <modal title="Modal title" class="modal" v-model="testModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
              <span class="modal-title">
                <strong>{{testWorkflow.name}}</strong>
              </span>
            </div>
            <div slot="modal-body" class="modal-body">
              <b-card no-block>
                <b-tabs card>
                  <!-- Tab Processar Workflow -->
                  <b-tab :title="`Executar`">
                    <div class="card">
                      <div class="card-header">
                        <strong class="pull-left">Parâmetros de entrada</strong>
                        <button type="button" class="btn btn-sm btn-secondary pull-right" @click="executeTest">Executar</button>
                      </div>
                      <div class="card-block">
                        <div class="checkbox">
                          <label for="checkbox1"><input v-model="testSync" type="checkbox" checked="checked" class="switch-input"> Chamada Síncrona
                          </label>
                        </div>
                        <label class="col-form-label">Body</label>
                        <vue-json-editor v-model="testBody" :showBtns="false"></vue-json-editor>
                      </div>
                    </div>
                    <div class="clearfix" />
                    <div v-show="testExecuted">
                      <div class="card">
                        <div class="card-header">
                          Resultado
                        </div>
                        <div class="card-block testResult">
                          <pre>{{testResult}}</pre>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <!-- Tab Continuar Workflow -->
                  <b-tab :title="` Continuar Execução`">
                    <div class="card">
                      <div class="card-header">
                        <strong class="pull-left">Parâmetros de entrada</strong>
                        <button type="button" class="btn btn-sm btn-secondary pull-right" @click="executeContinueTest">Executar</button>
                      </div>
                      <div class="card-block">
                        <label class="col-form-label">Session Id</label>
                        <input type="text" class="form-control" name="session id" v-model="testSessionId">
                        <label class="col-form-label">Message Name</label>
                        <input type="text" class="form-control" name="message name" v-model="testMsgName">
                        <div class="checkbox" style="margin-top:10px">
                          <label for="checkbox1"><input v-model="continueTestSync" type="checkbox" checked="checked" class="switch-input"> Chamada Síncrona
                          </label>
                        </div>
                        <label class="col-form-label">Body</label>
                        <vue-json-editor v-model="continueTestBody" :showBtns="false"></vue-json-editor>
                      </div>
                    </div>
                    <div class="clearfix" />
                    <div v-show="continueTestExecuted">
                      <div class="card">
                        <div class="card-header">
                          Resultado
                        </div>
                        <div class="card-block testResult">
                          <pre>{{continueTestResult}}</pre>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
            <div slot="modal-footer" class="modal-footer">
              <button type="button" class="btn btn-sm btn-default" @click="testModal = false">Fechar</button>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modal from 'vue-strap/src/Modal'
import axios from 'axios'
import vueJsonEditor from 'vue-json-editor'

export default {
  name: 'workflows',
  components: {
    modal, vueJsonEditor
  },
  data() {
    return {
      deleteModal: false,
      testModal: false,
      workflow: {},
      workflows: [],
      testWorkflow: {},
      testBody: {},
      continueTestBody: {},
      testResult: [],
      continueTestResult: [],
      testExecuted: false,
      continueTestExecuted: false,
      testSync: false,
      continueTestSync: false,
      testSessionId: '',
      testMsgName: ''
    }
  },
  computed: {
    orderedItems: function() {
      return this.workflows.sort((a, b) => {
        return Date.parse(b.lastUpdate) - Date.parse(a.lastUpdate)
      })
    }
  },
  created() {
    this.loadItems()
  },
  methods: {
    deleteItem() {
      this.deleteModal = false
      axios.delete(process.env.BEAST_MANAGER_API_URL + 'workflows/' + this.workflow.id).then(response => {
        this.showSuccess('Workflow excluído com sucesso!')
        this.loadItems()
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao excluir o workflow.')
      })
    },
    loadItems() {
      axios.get(process.env.BEAST_MANAGER_API_URL + 'workflows').then(response => {
        this.workflows = response.data.results
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao carregar os workflows.')
      })
    },
    showModal(item) {
      this.workflow = item
      this.deleteModal = true
    },
    showTestModal(item) {
      this.testWorkflow = item
      this.testExecuted = false
      this.testModal = true
    },
    executeTest() {
      this.testExecuted = false
      var id = this.testWorkflow.id
      axios.post(`${process.env.BEAST_SERVER_API_URL}workflows/${id}/process?sync=${this.testSync}`, this.testBody).then(response => {
        this.testResult = response.data
        this.testExecuted = true
        if (response.data.sessionId !== undefined) {
          this.testSessionId = response.data.sessionId
        }
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao testar a decision.')
      })
    },
    executeContinueTest() {
      this.continueTestExecuted = false
      var id = this.testWorkflow.id
      axios.put(`${process.env.BEAST_SERVER_API_URL}workflows/${id}/process?sync=${this.testSync}&sessionId=${this.testSessionId}&messageName=${this.testMsgName}`, this.testBody).then(response => {
        this.continueTestResult = response.data
        this.continueTestExecuted = true
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao testar a decision.')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?04ac9a0d